import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { DatePicker } from '@shape-ds/components';
import { t } from 'i18next';
import { dayjs } from 'lib/dayjs';
import { Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormInputProps } from 'ui/FormComponents/FormInputProps';

export const validateDate = (value: string, minDate?: string) => {
  if (!minDate || !value) return true;
  if (minDate && (dayjs(value).isAfter(dayjs(minDate)) || dayjs(value).isSame(dayjs(minDate)))) {
    return true;
  }
  return t('components:inputs.invalid_date');
};

export const FormDatePicker = <T extends FieldValues>({
  name,
  control,
  label,
  dateFormat,
  isRequired,
  minDate,
  disabled,
  placeHolderText,
  classname,
  disableOpenPicker = false,
  onChangeCallback,
  ...props
}: FormInputProps<T> & { onChangeCallback?: (date?: string) => void }) => {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired ? t('components:inputs.required_field') : false,
        validate: {
          validateDate: (value) => validateDate(value, minDate),
        },
      }}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <div data-testid={name} className={name.replace(/\./g, '-')}>
            <DatePicker
              {...props}
              required={isRequired}
              label={label}
              data-testid={name}
              helperText={error?.message}
              format={dateFormat}
              error={!!error}
              onChange={(date) => {
                onChange(date?.toString() ? date.toString() : undefined);
                onChangeCallback?.(date?.toString() ? date.toString() : undefined);
              }}
              value={value ? dayjs(value) : null}
              fullWidth
              minDate={minDate ? dayjs(minDate) : undefined}
              className={`cd-date${classname ? ` ${classname}` : ''}`}
              disabled={disabled}
              disableOpenPicker={disableOpenPicker}
              slots={{ openPickerIcon: CalendarMonthIcon }}
            />
          </div>
        );
      }}
    />
  );
};
